// extracted by mini-css-extract-plugin
module.exports = {"textarea":"Inspectlet_textarea__1hQzZ","textareaContainer":"Inspectlet_textareaContainer__3jfXQ"};